<template>
  <!-- 区域配置页面 -->
  <Row class="areaConfig no-cancel-tree">
    <!-- 左侧的区域信息 -->
    <i-col span="9" class="left-box">
      <h3>{{ $t("deviceSip.area") }}</h3>
      <config-tree
        ref="configTree"
        :key="timeStamp"
        :current-step="currentStep"
        :current-chosen-node="currentNode['$treeNodeId']"
        @selectTree="selectTree"
      ></config-tree>
    </i-col>
    <!-- 右侧的功能选项 -->
    <i-col span="14" class="right-box">
      <div class="fun-box">
        <Button
          class="pro-edit-color forbit-cancel-tree"
          icon="md-checkbox-outline"
          size="large"
          @click="showAddAreaModal(1)"
        >
          {{ $t("deviceSip.editArea") }}
        </Button>
        <Button
          class="pro-add-color forbit-cancel-tree"
          icon="md-add-circle"
          size="large"
          @click="showAddAreaModal(0)"
        >
          {{ $t("deviceSip.addArea") }}
        </Button>
        <Button
          class="pro-batch-color forbit-cancel-tree"
          icon="md-albums"
          size="large"
          @click="showAddBatchAreaModal"
        >
          {{ $t("deviceSip.batchArea") }}
        </Button>
        <Button
          icon="ios-trash"
          class="pro-del-color forbit-cancel-tree"
          size="large"
          @click="showDelAreaModal"
        >
          {{ $t("deviceSip.deleteArea") }}
        </Button>
      </div>
      <!-- 已选中区域点 -->
      <div v-if="currentNode.code" class="content-box forbit-cancel-tree">
        <h2>{{ $t("deviceSip.area") }}</h2>
        <h4>
          <span>
            <span class="error-color">*</span>
            {{ $t("deviceSip.areaName") }}
          </span>
          <p>{{ currentNode.name }}</p>
        </h4>
        <h4>
          <span>
            <span class="error-color">*</span>
            {{ $t("deviceSip.areaNo") }}
          </span>
          <p>{{ currentNode.code }}</p>
        </h4>
      </div>
    </i-col>
    <!-- 底部按钮 底部居中垂直 -->
    <i-col span="24" class="footer-btn forbit-cancel-tree">
      <!-- 离线配置改动点8 -->
      <Button type="primary" ghost size="large" @click="setCurrentStep(0)">
        {{ $t("deviceSip.prev") }}
      </Button>
      <Button
        class="forbit-cancel-tree"
        type="primary"
        size="large"
        @click="setCurrentStep(2)"
      >
        {{ $t("deviceSip.next") }}
      </Button>
    </i-col>
    <!-- 新增单个区域modal -->
    <add-area-modal
      ref="addAreaModal"
      :area-type="areaType"
      :current-node="currentNode"
      @updateTree="updateTree"
    ></add-area-modal>
    <!-- 新增批量区域modal -->
    <add-batch-area-modal
      ref="addBatchAreaModal"
      :current-node="currentNode"
      @updateTree="updateTree"
    ></add-batch-area-modal>
    <!-- 删除弹窗 -->
    <confirmModal
      ref="confirmModal"
      class="forbit-cancel-tree"
      @afterComfirm="delArea"
    >
      <div slot="info">
        <p class="p-text">
          {{ $t("updateNewSip.deleteArea1") }}"{{ delNamePath }}"?
        </p>
        <p class="p-text">{{ $t("updateNewSip.deleteArea2") }}</p>
      </div>
    </confirmModal>
    <!-- 提交确认弹窗 -->
    <modal class="forbit-cancel-tree" ref="resultModal" :type="modalType">
    </modal>
  </Row>
</template>
<script>
import configTree from "./configTree";
import addAreaModal from "./addAreaModal";
import addBatchAreaModal from "./addBatchAreaModal";

import { mapState } from "vuex";
import { getAllParentNode } from "@/utils/tree";

export default {
  name: "areaConfig",
  components: {
    configTree,
    addAreaModal,
    addBatchAreaModal,
  },
  filters: {},
  directives: {},
  mixins: {},
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      modalType: false,
      timeStamp: new Date().getTime(),
      areaType: 0, // 区域modal的操作类型 ：0新增，1编辑
      currentNode: {}, // 当前选中的node节点
      delNamePath: "", // 删除展示的名称
    };
  },
  computed: {
    ...mapState("projectConfig", ["areaData", "areaDeviceData"]),
  },
  watch: {},
  created() {},
  mounted() {},
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    // 更新树组件的渲染
    updateTree() {
      this.timeStamp = new Date().getTime();
      this.$Spin.hide();
    },
    // 选中过的树节点
    selectTree(key) {
      this.currentNode = key;
    },
    // 展示单个添加
    showAddAreaModal(areaType) {
      // areaType操作类型 ：0新增，1编辑
      if (areaType === 1 && !this.currentNode.code) {
        this.$Message.error(this.$t("deviceSip.areaTip1"));
        return;
      }
      this.areaType = areaType;
      this.$refs.addAreaModal.dialogVisible = true;
    },
    // 展示批量添加
    showAddBatchAreaModal() {
      this.$refs.addBatchAreaModal.dialogVisible = true;
    },
    // 展示删除区域modal
    showDelAreaModal() {
      if (!this.currentNode.code) {
        this.$Message.error(this.$t("deviceSip.areaTip2"));
        return;
      }
      this.delNamePath = this.setNamePath();
      this.$refs.confirmModal.dialogVisible = true;
    },
    // 删除区域
    delArea() {
      // 清除选中的节点
      this.setDeepArrData(
        this.areaDeviceData,
        this.currentNode["$treeNodeId"],
        "$treeNodeId",
        "groupList",
        "name"
      );

      this.$store.commit(
        "projectConfig/SET_AREADEVICEDATA",
        this.areaDeviceData
      );
      this.currentNode = {};

      // 更新树组件的渲染
      this.$emit("updateTree");
    },
    // 离线配置改动点7
    // 下一步
    setCurrentStep(currentStep) {
      this.updateTree();
      this.$emit("setCurrentStep", currentStep);
    },
    // 递归查找，找到后删除当前选中的区域
    setDeepArrData(
      arr,
      id,
      idStr = "$treeNodeId",
      child = "groupList",
      name = "name"
    ) {
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        if (item[idStr] === id) {
          // 遍历
          if (item.level === 1) {
            // 首层设备需要
            this.areaDeviceData.splice(i, 1);
            this.updateTree();
            this.$forceUpdate();
          } else {
            arr.splice(i, 1);
          }
          // 操作成功，关闭弹窗
          this.$refs.resultModal.dialogVisible = true;
          this.modalType = true;
          return;
        }
        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrData(item[child], id, idStr, child, name);
        }
      }
    },
    // 设置namePath显示
    setNamePath() {
      if (!this.currentNode.code) {
        // 无选中的点
        this.delNamePath = "";
      } else {
        // 选中当前点
        if (this.currentNode.namePath) {
          this.delNamePath = this.currentNode.namePath;
        } else {
          // 自己找祖先节点
          let allParentNodeArray = getAllParentNode(
            this.areaDeviceData,
            this.currentNode["$treeNodeId"]
          );

          if (allParentNodeArray.length > 0) {
            // 有祖先节点
            // 倒转，按远到近排
            allParentNodeArray = allParentNodeArray.reverse();
            allParentNodeArray = allParentNodeArray.map((item) => {
              return item.name;
            });
            allParentNodeArray.push(this.currentNode.name);
            console.log("this.delNamePath:::" + this.delNamePath);
            this.delNamePath = allParentNodeArray.join("-");
          } else {
            this.delNamePath = "";
          }
        }
      }
      return this.delNamePath;
    },
  },
};
</script>
<style lang="scss" scoped>
.areaConfig {
  width: 100%;
  height: 100%;

  .left-box,
  .right-box {
    background: #fff;
    height: 90%;
  }
  .left-box {
    margin-right: 30px;
    overflow: auto;
    h3 {
      padding: 30px 0 20px 30px;
    }
  }
  .right-box {
    padding: 30px 50px;
  }
  .fun-box {
    padding-bottom: 30px;
    border-bottom: 1px solid #e2e2e2;
    & > button {
      margin-right: 20px;
      margin-top: 10px;
    }
  }
  .content-box {
    padding-top: 30px;
    h2,
    h4 {
      display: flex;
    }
    h2 {
      margin-bottom: 30px;
    }
    h4 {
      margin-bottom: 40px;
      p {
        margin-left: 30px;
      }
    }
  }
  .footer-btn {
    margin-top: 20px;
    text-align: center;

    button {
      padding: 0 30px;
      margin-right: 20px;
    }
  }
}
</style>
